export default "__VITE_ASSET__Cg6IG7_y__"